import React, {useEffect, useMemo} from "react";
import {observer} from "mobx-react-lite";
import {Container, Row, Col, Card} from "react-bootstrap";
import Spinner from "../components/Spinner";
import RobokassaResultPageStore from "../stores/pages/RobokassaResultPageStore";
import ErrorDisplay from "./ErrorDisplay";

const RobokassaResultPage: React.FC = observer(() => {
  const store = useMemo(() => new RobokassaResultPageStore(), []);

  useEffect(() => {
    store.load();

    return () => {
      store.dispose();
    };
  }, [store]);

  if (store.state === "error") {
    return (
      <Container>
        <Row>
          <Col>
            <ErrorDisplay error={store.error}/>
          </Col>
        </Row>
      </Container>
    );
  }

  if (store.state === "no_application") {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card>
              <Card.Body className="text-center">
                <Card.Title>No Application Found</Card.Title>
                <Card.Text>
                  We couldn't find an active application associated with your account.
                  Please contact support if you believe this is an error.
                </Card.Text>
                <a href="/" className="btn btn-primary">
                  Go to Home
                </a>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card>
            <Card.Body className="text-center py-5">
              <div className="mb-4">
                <Spinner/>
              </div>
              <h4>We are processing your payment</h4>
              <p className="text-muted">
                Please wait while we confirm your payment status.
                This page will automatically update when complete.
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
});

export default RobokassaResultPage;
